export enum FACT_NAMES_STRING {
  COMPARABLE_LOAN_HISTORY = "COMPARABLE_LOAN_HISTORY",
  DRIVER_STRUCTURE = "DRIVER_STRUCTURE",
  HOME_OWNERSHIP = "HOME_OWNERSHIP",
}
